module.exports = __webpack_public_path__ + "static/media/cardground.e0628d65.JPG";